<template>
  <!-- bit位映射表 -->
  <div>
    <el-form :model="tableList" :rules="tableList.bitTableRules" ref="bitTable">
      <el-table :data="tableList.tableData" border row-key="index"
        :row-class-name="styleDuplicateBit" :header-cell-style="headerStyle" max-height="600">
        <!-- 映射表 列 -->
        <el-table-column type="index" width="60" label="序号" align="center" />
        <el-table-column label="起始比特位(Bit)"  prop="startingBit" align="center">
          <template #default="scope">
            <el-form-item :prop="'tableData.'+scope.$index+'.startingBit'" :rules="tableList.bitTableRules.startingBit">
              <el-input size="small" v-model="scope.row.startingBit" type="number" min="0" @input="handleInputBit(scope.row)" placeholder="请输入起始比特位"/>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="长度" prop="bitLength" align="center">
          <template #default="scope">
            <el-form-item :prop="'tableData.'+scope.$index+'.bitLength'" :rules="tableList.bitTableRules.bitLength">
              <el-input size="small" v-model="scope.row.bitLength" type="number" min="1" @input="handleInputLength(scope.row)" />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="映射内容" prop="name" align="center">
          <template #default="scope">
            <el-form-item :prop="'tableData.'+scope.$index+'.name'" :rules="tableList.bitTableRules.name">
              <el-input size="small" v-model="scope.row.name" placeholder="请输入映射内容" />
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 键值对 根据映射个数变化 -->
        <el-table-column label="键值对" prop="bitValueKey" width="620" align="center">
          <template #default="scope">
              <DynamicRows 
                ref="dynamicRows" 
                :rowData="scope.row.bitValueKey"
                @update:row-data="val => updateMappingRow(scope.row, val)" 
                @addRow="addMappingRow(scope.row, $event)"
                @removeRow="removeMappingRow(scope.row, $event)"
                :bitOrValue="bitOrValue"
              />
          </template>
        </el-table-column>
        <!--操作栏-->
        <el-table-column label="操作" width="180" align="center">
          <template #default="scope">
            <!-- <table-operation-bar @addRow="addBitRow(scope.$index)" @removeRow=removeBitRow(scope.$index)
              :forbidden="this.duplicateBits.length != 0" @copyRow="copyRow(scope)"/> -->
              <table-operation-bar @addRow="addBitRow(scope.$index)" @removeRow=removeBitRow(scope.$index)  @copyRow="copyRow(scope)"/>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>

<script>
import DynamicRows from '@/components/table/DynamicRows.vue'
import TableOperationBar from '@/components/table/TableOperationBar.vue'
import { handleDragRow, hasDuplicateData, styleDuplicateRow, handleCopyRow } from '@/utils/tableRowHandlers'
import { handleAddRowBit, handleDeleteRowBit } from '@/utils/mappingRowHandlers'
import { bitTableRules } from '@/data/rules'

export default {
  name: 'BitMappingTable',
  components: {
    DynamicRows,
    TableOperationBar
  },
  props: {
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 表格类型 add: 创建 edit: 编辑
    type: {
      type: String,
      default: 'add'
    },
    bitOrValue: {
      type: String,
      default: '1'
    }
  },
  emits: ['update:tableData'],
  computed: {
    // 本地存储表格数据
    formTableData: {
      get () {
        return this.tableData
      },
      set (val) {
        this.$emit('update:tableData', val)
      }
    }
  },
  data () {
    return {
      // 重复比特位
      duplicateBits: [],
      // 表格数据格式
      dataFormat: {
        id: undefined,
        index: '',
        startingBit: '',
        bitLength: '',
        name: '',
        bitValueKey: [{ id: undefined, index: '', key: '', value: '' }]
      },
      tableList: {
        tableData: [], // 初始化为空数组
        // 表格校验规则
        bitTableRules: bitTableRules
      }
    }
  },
  mounted () {
    // 如果是是创建页面，初始化表格数据
    if (this.type === 'add' && this.formTableData.length === 0) {
      this.formTableData.push(JSON.parse(JSON.stringify(this.dataFormat)))
    }
    this.tableList.tableData = this.formTableData
    setTimeout(() => {
      handleDragRow(this.tableList.tableData, (sortedData) => {
        this.tableList.tableData = sortedData
      })
    }, 1000)
  },
  watch: {
    // 监听formTableData变化
    formTableData: {
      handler () {
        this.tableList.tableData = this.formTableData
        // 检查比特位是否有重复
        this.duplicateBits = hasDuplicateData(this.formTableData, 'startingBit')
        // 提示重复比特位
        if (this.duplicateBits.length > 0) {
          this.$message.warning('比特位不能重复')
        }
      },
      deep: true
    },
    tableData: {
      handler (val) {
        this.$emit('update:tableData', val)
        this.tableList.tableData = val
      },
      deep: true
    }
  },
 methods: {
    // 新增方法：更新键值对行数据
    updateMappingRow(row, newData) {
      row.bitValueKey = newData;
    },
    headerStyle({ row, column, rowIndex, columnIndex }) {
      // 或者返回对象形式
      return {
        'background-color': '#fafafa',
        'color': '#333',
        'font-weight': 'bold',
        'padding': '0',
        'height': '36px'
      }
    },
    // 重复比特位样式
    styleDuplicateBit ({ row }) {
      return styleDuplicateRow(row, this.duplicateBits, 'startingBit')
    },
    // 输入数值改为数字
    handleInputBit (row) {
      if (!row.startingBit) row.startingBit = 0
      row.startingBit = parseInt(row.startingBit, 10)
    },
    // 根据输入框变化调整行数
    handleInputLength (row) {
      // row = handleRowChange(row, 'bitLength', 'bitValueKey')
    },
    // 复制一行
    copyRow (copyRow) {
      const newCopyRow = JSON.parse(JSON.stringify(copyRow.row))
      newCopyRow.startingBit = (this.tableList.tableData.length + 1)
      newCopyRow.id = ''
      this.tableList.tableData = handleCopyRow(this.tableList.tableData, newCopyRow, copyRow.$index)
    },
    // 新增一行映射
    addMappingRow (row, index) {
      if (row.bitValueKey.length >= Math.pow(2, row.bitLength)) {
        this.$message.warning('比特位映射值不能超过2的比特位长度次方')
      } else {
        row = handleAddRowBit(row, 'bitLength', 'bitValueKey', index)
      }
    },
    // 删除一行映射
    removeMappingRow (row, index) {
      if (row.bitValueKey.length <= 1) {
        this.$message.warning('至少保留一行')
      } else {
        row = handleDeleteRowBit(row, 'bitLength', 'bitValueKey', index)
      }
    },
    // 新增一行比特位
    addBitRow (index) {
      // 计算新的起始比特位= 上一行的起始比特位 + 上一行的长度
      const lastRow = this.formTableData[index]
      const newStartingBit = parseInt(lastRow.startingBit) + parseInt(lastRow.bitLength)
      const newRowIndex = lastRow.index + 1
      // 创建新的行数据
      const newRow = {
        index: newRowIndex,
        startingBit: newStartingBit,
        bitLength: 1,
        bitValueKey: [{ id: undefined, key: '', value: '' }]
      }
      // 将新的行数据添加到tableData中
      this.formTableData.splice(index + 1, 0, newRow)
    },
    // 删除一行比特位
    removeBitRow (index) {
      // 如果只有一行，不允许删除
      if (this.formTableData.length <= 1) {
        this.$message.warning('至少保留一行')
        return
      }
      this.formTableData.splice(index, 1)
    },
    // 表单校验
    async handleValidation () {
      try {
        // 校验表格数据（测试操作）
        const valid1 = await this.$refs.bitTable.validate()
        // 校验动态行数据（操作参数）
        const valid2 = await this.$refs.dynamicRows.handleValidation()
        return Promise.all([valid1, valid2])
      } catch (error) {
        return false
      }
    }
  }
}
</script>

<style>
/* @import url(@/assets/styles/img.css); */
.flex_icon{
  display: flex;
  flex-direction: row;
  margin: 10px 0px;
  align-items: center;
  justify-content: center;
}
.drag_handle{
  cursor: grab;
}
.forbidden{
  cursor: not-allowed;
}
.el-table .warning-row {
  --el-table-tr-bg-color: rgb(251, 182, 182);
  --el-table-row-hover-bg-color: rgba(255, 37, 37, 0.4);
}
</style>
